export default {"src":"/_next/static/media/crossMint.9b975133.svg","height":14,"width":15,"blurWidth":0,"blurHeight":0};